<script module>
  export const meta = {
    title: 'Movements',
    teaser:
      'Integrate natural, everyday movements into your life with Pausly to\nimprove well-being without the intensity of traditional exercise. With a focus\non safety, accessibility, and listening to your body, discover new ways to\nenhance your health regardless of fitness level.\n',
    sort: 0,
  }
</script>

<p>
  Pausly focuses on integrating beneficial movements into your daily routine,
  aiming to enhance well-being in a manner that complements, rather than
  replaces, traditional sports or extensive physical exercise. Our approach
  centers around the natural, everyday actions your body can take to improve
  health, emphasizing ease and accessibility for all fitness levels.
</p>
<h2>Why "Movement" Not "Exercise"?</h2>
<p>
  The term "movement" was chosen with intention. By focusing on movement, we
  emphasize the natural, everyday actions your body can take to improve health
  without the intensity often associated with the word "exercise." It's about
  integrating beneficial physical activity into your day, no matter your fitness
  level.
</p>
<h2>Safety and Effectiveness</h2>
<p>
  Your health and safety are our top priorities. That's why we collaborate with
  physiotherapists to develop movements that are both safe and effective. Every
  movement is designed with your well-being in mind, ensuring you can proceed
  with confidence.
</p>
<h2>Listening to Your Body</h2>
<p>
  Above all, we encourage you to listen to your body. Should you experience any
  discomfort or pain while performing a movement, please stop immediately. This
  is crucial in preventing injury and ensuring a safe and enjoyable experience
  with Pausly.
</p>
<h2>Always Something New to Discover</h2>
<p>
  We believe in keeping things fresh and exciting. That's why we are continually
  expanding our library of movements. Whether you’re on the free tier, with
  access to 30 movements, or a Pausly Plus member, enjoying 120+ movements,
  there’s always something new to explore and add to your routine.
</p>
<h2>Our Movement Categories</h2>
<p>
  Pausly's movements fall into two main categories: strength and stretch. Each
  session is thoughtfully designed to alternate between these types, offering a
  balanced approach to your physical activity. Strength movements target muscle
  building and endurance, while stretch movements focus on flexibility and
  relaxation.
</p>
<p>
  Whether you’re here to add a bit more activity into your day, improve
  flexibility, or build strength in a gentle manner, Pausly is your companion on
  this journey. Remember, it's not about perfection; it's about making small,
  sustainable shifts towards a more active and healthier lifestyle.
</p>
